import index from '../components/index';
import edit from '../components/edit';
import editPoint from '../components/points/editPoint';

export default [
    {
        path: '/meetings',
        component: index,
        name: 'meetings',
        meta: { auth: true },
    },
    {
        path: '/meetings/:id/edit',
        component: edit,
        name: 'meetings.edit',
        props: { default: true },
        meta: { auth: true },
    },
    {
        path: '/meeting/:meetingId/points/:id/edit',
        component: editPoint,
        name: 'points.edit',
        props: { default: true },
        meta: { auth: true },
    },
]